// API Configuration
const explicitBaseUrl = process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim();

// Default to the hosted API domain unless explicitly overridden via env variable.
const rawBaseUrl = explicitBaseUrl || 'https://prism-api.loafstack.dev';

// Normalize to avoid trailing slash inconsistencies across fetch helpers
export const API_BASE_URL = rawBaseUrl.endsWith('/') ? rawBaseUrl.slice(0, -1) : rawBaseUrl;